export var programmeHeader = 'September 2024 - June 2025';

export var programmeNotice = 'Meetings normally begin at 7.45pm for 8.00pm. Members entering their work into internal competitions are requested to arrive before 7.45pm. Competitions will start promptly at 8.00pm and the competition secretary may not be able to accept work arriving after this time.';

export var programmeEvents = [
    {
        header: '10th September 2024',
        detail: 'Members` Evening: Q&A Session'
    },
    {
        header: '24th September 2024',
        detail: 'Arthur Mole Lecture, Damien Demolder - Light and Life on the Streets.'
    },
    {
        header: '8th October 2024',
        detail: '1st Print Competition - Open Topic - Judge: Rob Bonfield'
    },
    {
        header: '22nd October 2024',
        detail: 'Jo Teasdale FRPS - The Factory - a look at how mannequins can be perceived'
    },
    {
        header: '2nd November 2024',
        detail: 'SPA Individual Competition.'
    },
    {
        header: '4th November 2024',
        detail: 'Concorde Trophy Competition - Hosted by Kingston Camera Club.'
    },
    {
        header: '5th November 2024',
        detail: '1st PDI Competition - Open Topic, Judge: Tim Clarke.'
    },
    {
        header: '26th November 2024',
        detail: 'Peter Merry - An Introduction to Street Photography.'
    },
    {
        header: '7th December 2024',
        detail: 'SPA Inter Club Print Competition. East Horsley Village Hall.'
    },
    {
        header: '10th December 2024',
        detail: 'Christmas Social Evening'
    },
    {
        header: '14th January 2025',
        detail: 'Viveca Koh - A Collection of Moments.'
    },
    {
        header: '28th January 2025',
        detail: '2nd Print Competition - Open Topic Judge: Paul Waller.'
    },
    {
        header: '11th February 2025',
        detail: 'Paul Sanders - Re-discovering Your Creative Mojo.'
    },
    {
        header: '24th February 2025',
        detail: 'Albany Cup Competition - Held at Guildford Photgraphic Society.'
    },
    {
        header: '25th February 2025',
        detail: 'Members` Evening'
    },
    {
        header: '11th March 2025',
        detail: '2nd PDI Competition - Topic : B&W Judge - Peter Merry LRPS.'
    },
    {
        header: '18th March 2025',
        detail: 'Rosebowl Competition.'
    },
    {
        header: '25th March 2025',
        detail: 'Linda Wevill - Expressing Creative Vision'
    },
    {
        header: '8th April 2025',
        detail: '3rd Print Competition - Topic: Nature - Judge : Sheena Rogers.'
    },
    {
        header: '22nd April 2025',
        detail: 'John Sherringham - One Light Set-up Demo'
    },
    {
        header: '10th May 2025',
        detail: 'SPA Inter Club PDI Competition, East Horsley Village Hall'
    },
    {
        header: '13th May 2025',
        detail: '3rd PDI Competition - Judge : Graham Mansfield'
    },
    {
        header: '27th May 2025',
        detail: 'Members` Evening'
    },
    {
        header: '10th June 2025',
        detail: 'Themed Competition - Topic - Food. Judge : Paul Graber'
    },
    {
        header: '24th June 2025',
        detail: 'AGM and Internal Club Competitions Awards - Exhibition Print & PDI submissions'
    },
    {
        header: '6th July 2025',
        detail: 'PAGB Inter Club PDI Championships, Warwick'
    },
    {
        header: '1st - 6th September 2025',
        detail: 'Annual Exhibition, Judged by Amanda Wright'
    },
    {
        header: '5th September 2025',
        detail: 'Awards Night'
    }
];


// WEBPACK FOOTER //
// ./src/data/programme.js